import React, { useState, useEffect, useRef, useMemo } from "react";
import qimg from "../assets/images/qoutes.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-calendar/dist/Calendar.css";
import { Link } from "react-router-dom";
import Announcementslider from "./Announcementslider";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

const quotes = [
  "A diamond is a piece of coal that is stuck to the job. Your most important work is always ahead of you, never behind you.",
  "The difference between ordinary and extraordinary is that little extra.",
  "Don’t try to be the best, try to be a better version than yesterday!",
  "There are no shortcuts to any place worth going.",
  "Believing in yourself is the first secret to success.",
  "Positive attitude will lead you to a positive outcome",
  "The only real limitation on your abilities is the level of your desires. If you want it badly enough, there are no",
  "Work hard in silence, Let your success make noise.",
  "Never give up because great things take time and some effort.",
  "Sooner or later, those who win are those who think they can.",
  "Trust yourself, you know more than you think you do.",
  "I was always looking outside myself for strength and confidence but it comes from within. It is there all the time.",
  "The expert in anything was once a beginner.",
];

const RecordSlider = () => {
  const [data, setData] = useState(null);
  const [userdata, setUserData] = useState(null);

  const [dailyEntryData, setdailyEntryData] = useState([]);

  const [focusedIndex, setFocusedIndex] = useState(0);
  const sliderContainer = useRef(null);

  const [userName, setUserName] = useState(""); // Define state for userName
  const [turnedUp, setTurnedUp] = useState(""); // Define state for turnedUp
  const [selected, setSelected] = useState(""); // Define state for turnedUp
  const [revenue, setRevenue] = useState(""); // Define state for turnedUp

  const [resume_forwarded, setResumeForwarded] = useState(""); // Define state for turnedUp

  const [userTarget, setUserTarget] = useState([]); // Define state for turnedUp
  const [userRevenueTarget, setUserRevenueTarget] = useState([]); // Define state for turnedUp

  const [imageSrc, setImageSrc] = useState(""); // Define state for imageSrc  const [announcements, setAnnouncements] = useState([]);
  const [recordData, setRecordData] = useState([]);
  const [messageShown, setMessageShown] = useState(false);
  const [pipelineandturnedup, setPipelineandturnedup] = useState(null);
  const [displayMode, setDisplayMode] = useState('target_candidates'); // 'target_candidates' or 'revenue'

  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem("access_token");

    // Redirect to the home page
    navigate("/");
  };

  // Fetch display mode settings
  useEffect(() => {
    const fetchDisplayMode = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        if (accessToken) {
          const response = await fetch(getApiUrl('/display-mode-settings/'), {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          const result = await response.json();
          setDisplayMode(result.pace_display_mode || 'target_candidates');
        }
      } catch (error) {
        console.error("Error fetching display mode:", error);
      }
    };
    fetchDisplayMode();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      fetch(getApiUrl(API_ENDPOINTS.GET_ALL_RECORDS), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setData(data.monthly_records || []); // Update state with fetched data
          setdailyEntryData(data.monthly_records || []); // Update state with fetched data
          setUserData(data.records || []); // Update state with fetched data

          setPipelineandturnedup(data.pipelineandturnedup || []);

        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (data) {
        setFocusedIndex((prevIndex) => {
          // const resumeForwardedPercentage = (data[focusedIndex].resume_forwarded / data[focusedIndex].target) * 100;
          const currentRecord = data[prevIndex];
         
          // Check if both resume_forwarded and target are defined and not zero
          if (
            currentRecord &&
            currentRecord.resume_forwarded !== null &&
            currentRecord.target !== null &&
            currentRecord.target !== 0
          ) {
            const resumeForwardedPercentage =
              (currentRecord.resume_forwarded / currentRecord.target) * 100;
            if (
              (currentRecord.target - currentRecord.resume_forwarded === 1 ||
                currentRecord.target - currentRecord.resume_forwarded === 2) &&
              !messageShown
            ) {
              
            }
          } else {
            console.log("Unable to calculate percentage: invalid data");
          }
          if (prevIndex === data.length - 1) {
            // navigate('/viewteamlead');
            navigate("/viewteamlead");

            //
          } else {
          }
          return (prevIndex + 1) % data.length;
        });
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [data]);

  // Get Color Combination for Achievement Percentage (Selected/Target or Revenue/Revenue Target)
  const getAchievementColor = (achieved, target) => {
    // Convert to numbers in case they're strings
    const achievedNum = parseFloat(achieved) || 0;
    const targetNum = parseFloat(target) || 0;
    
    if (!targetNum || targetNum === 0) return "#D8DBD7"; // Gray for no target
    const percentage = (achievedNum / targetNum) * 100;

    if (percentage >= 100) {
      return "#0284c7"; // Blue for 100%
    } else if (percentage >= 95) {
      return "#7ED957"; // Green for 95-100%
    } else if (percentage >= 85) {
      return "#FFDE59"; // Yellow for 85-95%
    } else {
      return "#FF5757"; // Red for < 85%
    }
  };

  useEffect(() => {
    const fetchRecordData = async () => {
      try {
        // Check if data exists and focusedIndex is valid
        if (!data || !Array.isArray(data) || data.length === 0) {
          return;
        }
        
        const currentRecord = data[focusedIndex];
        
        // Check if currentRecord exists and has an id
        if (!currentRecord || !currentRecord.id) {
          return;
        }
        
        const response = await axios.get(
          getApiUrl(`/record/${currentRecord.id}/`),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        setRecordData(response.data);
      } catch (error) {
        console.error("Error fetching record data:", error);
      }
    };

    fetchRecordData();
  }, [focusedIndex, data]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // Add any other settings you need
  };

  const sortedData = useMemo(() => {
    if (!dailyEntryData || !pipelineandturnedup || !userdata) return [];

    return dailyEntryData
      .map((entry) => {
        const pipeline =
          pipelineandturnedup.find((item) => item.user === entry.user)
            ?.pipline || 0;
        const turnedUpRatio =
          entry.turned_up && pipeline
            ? ((entry.selected + entry.turned_up) / entry.resume_forwarded) *
              100
            : 0;
        const correspondingRecord = userdata.find(
          (record) => record.id === entry.user
        );
        const targetRev = correspondingRecord ? correspondingRecord.revenue : 0;
        const target = correspondingRecord ? correspondingRecord.target : 0;

        return {
          ...entry,
          pipeline,
          turnedUpRatio,
          targetRev,
          target,
        };
      })
      .sort((a, b) => {
        // Sort based on display mode
        const bExp = isNaN(b.expected_revenue) ? 0 : parseFloat(b.expected_revenue);
        const aExp = isNaN(a.expected_revenue) ? 0 : parseFloat(a.expected_revenue);
        const bRev = isNaN(b.revenue) ? 0 : parseFloat(b.revenue);
        const aRev = isNaN(a.revenue) ? 0 : parseFloat(a.revenue);

        if (displayMode === 'revenue') {
          // Sort by expected revenue first when in revenue mode
          if (Math.abs(bExp - aExp) > 0.01) return bExp - aExp;
          if (Math.abs(bRev - aRev) > 0.01) return bRev - aRev;
          if (b.selected !== a.selected) return b.selected - a.selected;
          if (b.resume_forwarded !== a.resume_forwarded)
            return b.resume_forwarded - a.resume_forwarded;
          if (b.turnedUpRatio !== a.turnedUpRatio)
            return b.turnedUpRatio - a.turnedUpRatio;
          return b.pipeline - a.pipeline;
        } else {
          // Sort by target/candidates (selected) first when in target mode
          if (b.selected !== a.selected) return b.selected - a.selected;
          if (Math.abs(bExp - aExp) > 0.01) return bExp - aExp;
          if (Math.abs(bRev - aRev) > 0.01) return bRev - aRev;
          if (b.resume_forwarded !== a.resume_forwarded)
            return b.resume_forwarded - a.resume_forwarded;
          if (b.turnedUpRatio !== a.turnedUpRatio)
            return b.turnedUpRatio - a.turnedUpRatio;
          return b.pipeline - a.pipeline;
        }
      });
  }, [dailyEntryData, pipelineandturnedup, userdata, displayMode]);

  // Calculate the totals for each column
  const totalForwarded = sortedData.reduce(
    (acc, curr) => acc + curr.resume_forwarded,
    0
  );
  const totalPipeline = sortedData.reduce(
    (acc, curr) => acc + curr.pipeline,
    0
  );
  const totalTurnedUp = sortedData.reduce(
    (acc, curr) => acc + curr.turned_up,
    0
  );
  const totalSelected = sortedData.reduce(
    (acc, curr) => acc + curr.selected,
    0
  );
  const totalRevenue = sortedData.reduce(
    (acc, curr) => acc + (isNaN(curr.revenue) ? 0 : parseFloat(curr.revenue)),
    0
  );
  const totalTargetRevenue = sortedData.reduce((acc, curr) => {
    const correspondingRecord = data.find((record) => record.id === curr.user);
    return acc + (correspondingRecord?.revenue || 0);
  }, 0);

  useEffect(() => {
    if (userdata && data && pipelineandturnedup) {
      // Find the corresponding record in userdata
      const correspondingRecord = userdata.find(
        (record) => record.id === sortedData[focusedIndex].user
      );

      // If a corresponding record is found, extract the image and name
      const imageSrc = correspondingRecord
        ? `${API_BASE_URL}${correspondingRecord.image}`
        : "";
      const userName = correspondingRecord ? correspondingRecord.name : "";
      const target = correspondingRecord ? correspondingRecord.target : "";
      const targetrev = correspondingRecord ? correspondingRecord.revenue : "";

      // Find the corresponding entry in pipelineandturnedup
      const pipelineAndTurnedUpEntry = pipelineandturnedup.find(
        (entry) => entry.user === sortedData[focusedIndex].user
      );
      // If corresponding entry is found, extract the turned_up value
      const turnedUpValue = pipelineAndTurnedUpEntry
        ? pipelineAndTurnedUpEntry.turned_up
        : "";

      // Update state variables with the extracted values
      setImageSrc(imageSrc);
      setUserName(userName);
      setUserTarget(target); // Target is fetched from data
      setUserRevenueTarget(targetrev);
      setTurnedUp(sortedData[focusedIndex].turned_up); // Turned up is fetched from data
      setSelected(sortedData[focusedIndex].selected); // Turned up is fetched from data
      setRevenue(sortedData[focusedIndex].revenue); // Turned up is fetched from data
      setResumeForwarded(sortedData[focusedIndex].resume_forwarded); // Turned up is fetched from data
    }
  }, [focusedIndex, userdata, data, pipelineandturnedup, userTarget]);

  return (
    <div className="relative sliderContainer" >
      <Slider {...settings}>
        {dailyEntryData &&
          sortedData.map((dailyEntry, index) => {
            return (
              <div key={index} class="recentContainer bg-white rounded-lg shadow-md p-2">
                <Announcementslider />
                <div class="row" style={{ marginLeft: "35px" }}>
                  <div class="col-12">
                    <div id="carouselExample" class="carousel slide">
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <div class="row">
                            <div class="col-7">
                              <div class="row">
                                <div
                                  class="col-8"
                                  style={{ marginTop: "30px", textAlign: "left" }}
                                >
                                  <h1 class="authorName" style={{ fontSize: '2rem', fontFamily: "" }}>{userName}</h1>
                                  <p class="authorPos">HR Associate</p>
                                  <Link
                                    className="signOutLinkRecord"
                                    to={{ pathname: "/" }}
                                    onClick={handleSignOut}
                                  >
                                    {" "}
                                    <i class="fa-solid fa-right-from-bracket"></i>
                                  </Link>
                                </div>
                                <div
                                  class="col-4"
                                  style={{ marginTop: "30px" }}
                                >
                                  <div class="targetBox">
                                    {data && data[focusedIndex] && (
                                      <React.Fragment
                                        key={data[focusedIndex].id}
                                      >
                                        <h3>
                                          {displayMode === 'revenue' 
                                            ? `${parseFloat(userRevenueTarget) || 0} lac`
                                            : userTarget || 0
                                          }
                                        </h3>
                                      </React.Fragment>
                                    )}
                                    <p>{displayMode === 'revenue' ? 'Revenue Target' : 'Target'}</p>
                                  </div>
                                </div>
                              </div>
                              <div class="row" style={{ marginTop: "15px" }}>
                                {data && data[focusedIndex] && (
                                  <>
                                    <div
                                      class="col-4"
                                    >
                                      <div
                                        class="resumeForward"
                                        style={{
                                          backgroundColor: "#f3f4f6", // Neutral gray - no color coding for counts
                                          color: "#1f2937", // Dark gray text
                                        }}
                                      >
                                        <React.Fragment
                                          key={data[focusedIndex].id}
                                        >
                                          <h3>{resume_forwarded}</h3>
                                        </React.Fragment>

                                        <p>Resume Forwarded</p>
                                      </div>
                                    </div>
                                    <div
                                      class="col-4"
                                    >
                                      <div class="turnedUp">
                                        {/* <h2>{data[focusedIndex].turned_up}</h2> */}

                                        <h3>{turnedUp}</h3>
                                        <p>Turned Up</p>
                                      </div>
                                    </div>
                                    <div
                                      class="col-4"
                                    >
                                      <div 
                                        class="selectionCand"
                                        style={{
                                          backgroundColor: displayMode === 'revenue'
                                            ? getAchievementColor(revenue || 0, userRevenueTarget || 1)
                                            : getAchievementColor(selected || 0, userTarget || 1),
                                          color: "#fff",
                                        }}
                                      >
                                        <h3>
                                          {displayMode === 'revenue' 
                                            ? `${parseFloat(revenue) || 0} lac`
                                            : selected || 0
                                          }
                                        </h3>

                                        <p>{displayMode === 'revenue' ? 'Revenue' : 'Selected Candidate'}</p>
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div
                                  className="col-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <div class="qoutesBoxx">
                                    <img src={qimg} />
                                    <q style={{ fontSize: '18px' }}>
                                      {quotes[focusedIndex]}
                                    </q>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-5 userImageDiv"
                              style={{ marginTop: "30px" }}
                            >
                              <img src={imageSrc} alt="" class="userImage" />
                              <div class="ranking">
                                <h2>{focusedIndex + 1}</h2>
                                <p>Ranking</p>
                              </div>
                            </div>
                          </div>
                          <div class="row"></div>
                        </div>
                        <div class="carousel-item"></div>
                        <div class="carousel-item"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default RecordSlider;
